import { ReactNode } from 'react';

import { classNames } from 'primereact/utils';

const AppCard = (props: { className?: string; title?: string; subtitle?: string; children: ReactNode }): JSX.Element => {
  const { className, title, subtitle, children } = props;

  return (
    <div className={classNames('shadow-sm border border-gray-100 rounded-xl px-5 bg-white min-w-0 overflow-hidden', className)}>
      {title && (
        <div className="flex flex-col pt-5">
          <div className="font-semibold text-gray-800 text-[1.15rem] tracking-[-0.01em]">{title}</div>
          {subtitle && <div className="text-gray-400 text-[0.8rem] mt-0.5">{subtitle}</div>}
        </div>
      )}
      <div className="py-4">{children}</div>
    </div>
  );
};

export default AppCard;
